import React, {useContext} from 'react';
import Configuration from './Configuration';

import ConfirmationPage from './ConfirmationPage';
import Integration from './Integration';
import {EasyOnboardContext} from '../../../helpers/context';

function ConfigPanel({setSelectedApp, isLoading}) {
  const {easyAuthWidgetData, setEasyAuthWidgetData} =
    useContext(EasyOnboardContext);
  return (
    <>
      <div className="flex flex-col gap-4 relative pb-14">
        <Configuration setApp={setSelectedApp} isLoading={isLoading} />
        <ConfirmationPage
          setUrl={e => {
            const url =
              e.target.value.startsWith('https://') ||
              e.target.value.startsWith('http://')
                ? e.target.value
                : `https://${e.target.value}`;
            setEasyAuthWidgetData({...easyAuthWidgetData, redirect_url: url});
          }}
          authWidget={easyAuthWidgetData}
          isChecked={!easyAuthWidgetData?.redirect_url}
        />
        <Integration />
      </div>
    </>
  );
}

export default ConfigPanel;
